import React from 'react'
import { bool } from 'prop-types'
import withSizes from 'react-sizes'
import FooterItems from './FooterItems'
import LargeScreenRefreshButton from './LargeScreenRefreshButton'

const Footer = ({ isMobile }) =>
  isMobile ? <FooterItems /> : <LargeScreenRefreshButton />

Footer.propTypes = {
  isMobile: bool.isRequired,
}

const mapSizesToProps = ({ width }) => ({ isMobile: width <= 750 })

export default withSizes(mapSizesToProps)(Footer)



// WEBPACK FOOTER //
// ./src/components/Elements/Footer/index.jsx